module.exports = __webpack_public_path__ + "static/media/gryphon_musee_hero_pastevent.cbd72b71.jpg";